module.exports = __webpack_public_path__ + "static/Muli-Regular-7dd038a30d3e0b7dc9ecd0d12c96be80.woff";